import { render, staticRenderFns } from "./ObjectMenuButton.vue?vue&type=template&id=7198099c&scoped=true&"
import script from "./ObjectMenuButton.vue?vue&type=script&lang=ts&"
export * from "./ObjectMenuButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7198099c",
  null
  
)

export default component.exports